import { displayFlex } from '@onhandtech/onhand-toolkit'
import styled from 'styled-components'

export const NotFound = styled.div`
  padding: 2rem;
  ${displayFlex({ flexDirection: 'column', alignItems: 'flex-start' })}
`

export const Status = styled.div`
  margin-top: 1rem;
`
